import React, { useCallback, useMemo, useState } from 'react';
import clsx from 'clsx';

import CommonPopper from '../common-popper/CommonPopper';
import { Input } from '../common-inputs';
import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';
import SortMenu from './SortMenu';

import '../common-dropdown/CommonDropdown.scss';
import './SortDropdown.scss';
import { SORT_ORDER } from '../../constants';

const SortDropdown = ({
  sort,
  options,
  direction = SORT_ORDER.ASC,
  onChange,
  disabled,
  placeholder = '',
  size = 'sm',
  maxWidth,
  name,
  closeOnApply,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const style = { maxWidth };

  const selectedOption = useMemo(() => options.find((op) => op.value === sort), [sort, options]);

  const handleOpenDropdown = useCallback(() => {
    !disabled ? setDropdownOpen(true) : null;
  }, [disabled]);

  const handleCloseDropdown = useCallback(() => {
    setDropdownOpen(false);
  }, []);

  const handleApplySort = useCallback(
    ({ sort, direction }) => {
      onChange({ sort, direction });

      if (closeOnApply) {
        setDropdownOpen(false);
      }
    },
    [onChange, closeOnApply],
  );

  return (
    <CommonPopper
      component={() => <SortMenu options={options} sort={sort} direction={direction} onApply={handleApplySort} />}
      disabled={disabled}
      isShowCaret={false}
      isOpen={closeOnApply ? dropdownOpen : undefined}
      disableCloseOnItemClick
      onOpen={handleOpenDropdown}
      onClose={handleCloseDropdown}>
      <div className={clsx('common-dropdown')} style={style}>
        <Input
          extraInputClass={clsx(!disabled && 'common-dropdown--pointer')}
          value={selectedOption?.label}
          placeholder={placeholder}
          isReadOnly
          name={name}
          size={size}
          disabled={disabled}
          RightIcon={
            <Icon
              icon={ICONS.CaretUp}
              disableCommonStyles
              className={clsx(
                'common-dropdown_icon',
                dropdownOpen ? 'common-dropdown_icon--up' : 'common-dropdown_icon--down',
              )}
            />
          }
        />
      </div>
    </CommonPopper>
  );
};

export default SortDropdown;
